export default {
	BUTTON_UPGRADE: 1,
	BUTTON_CONTACT: 2,
	BUTTON_NO_THANKS: 3,
	BUTTON_REMIND_LATER: 4,
	BUTTON_CONTINUE: 5,
	BUTTON_GOT_IT_CANCEL: 6,
	BUTTON_GOT_IT_CONTINUE: 7,
	BUTTON_GOT_IT_CONTINUE2: 8,
	BUTTON_LEARN_MORE: 9,
	BUTTON_SUBS_GO_TO_DASHBOARD: 10,
	BUTTON_ENABLE_NOW: 11,
	BUTTON_CONTACT_ADMIN: 12,
	NO_BUTTON: 13,
}
